export * from './objekte-sorter.component';
export * from './objekte-sorter.component.module';